module.exports = __webpack_public_path__ + "static/media/title-how-to-come.75b036b4.png";